import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.o4h_1 = source;
        this.p4h_1 = false;
        this.q4h_1 = new (Buffer())();
      }
      v3v() {
        return this.q4h_1;
      }
      k4g(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.p4h_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        if (this.q4h_1.q2() === 0n) {
          var read = this.o4h_1.k4g(this.q4h_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.q4h_1.q2();
        var toRead = byteCount <= b ? byteCount : b;
        return this.q4h_1.k4g(sink, toRead);
      }
      w3v() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.p4h_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return this.q4h_1.w3v() && this.o4h_1.k4g(this.q4h_1, 8192n) === -1n;
      }
      x3v(byteCount) {
        if (!this.c3w(byteCount))
          throw EOFException().p4f("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      c3w(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.p4h_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        while (this.q4h_1.q2() < byteCount) {
          if (this.o4h_1.k4g(this.q4h_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      f3w() {
        this.x3v(1n);
        return this.q4h_1.f3w();
      }
      i4g(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.q4h_1.q2() === 0n) {
          var read = this.o4h_1.k4g(this.q4h_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q4h_1.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$1 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$1);
        return this.q4h_1.i4g(sink, startIndex, startIndex + toRead | 0);
      }
      m4g(sink, byteCount) {
        try {
          this.x3v(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.l4g(this.q4h_1, this.q4h_1.q2());
            throw e;
          } else {
            throw $p;
          }
        }
        this.q4h_1.m4g(sink, byteCount);
      }
      n4g(sink) {
        var totalBytesWritten = 0n;
        while (!(this.o4h_1.k4g(this.q4h_1, 8192n) === -1n)) {
          var emitByteCount = this.q4h_1.g4g();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.l4g(this.q4h_1, emitByteCount);
          }
        }
        if (this.q4h_1.q2() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.q4h_1.q2());
          sink.l4g(this.q4h_1, this.q4h_1.q2());
        }
        return totalBytesWritten;
      }
      z4f() {
        this.x3v(2n);
        return this.q4h_1.z4f();
      }
      x3x() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.p4h_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      l6() {
        if (this.p4h_1)
          return Unit_instance;
        this.p4h_1 = true;
        this.o4h_1.l6();
        this.q4h_1.s4();
      }
      toString() {
        return 'buffered(' + toString(this.o4h_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
